import React from 'react';

import { ProtectorType } from 'core/constants';

import { AnswerTypes } from 'utils/api/modules/incidents/incidents.types';
import { EnumOptions } from 'utils/api/modules/entities/entities.types';

import EntitiesFormField from 'containers/EntitiesFormSubmission/components/EntitiesFormField/EntitiesFormField';

import { EnumOption, childOptionsForParent } from './cascade';

// The Category -> Procedure narrowing inside a procedures entry. Show-all-then-narrow: the dropdown
// offers every option until the parent (Category) is answered, then narrows to that parent's group.
// Deliberately never locked/hidden — ADR-87, Adrián's 2026-06-09 call (see prototype PR #779 CascadeField).
// Holds no answer state of its own — the parent value and clearing are owned by the caller.

interface CascadeFieldProps {
  type: ProtectorType;
  description: string;
  options: EnumOption[];
  dependsOn: string;
  parentValue?: string[];
  value?: AnswerTypes;
  onChange: (value: AnswerTypes) => void;
  requiredNotFilled?: boolean;
  errorMessage?: string;
}

export const CascadeField = ({
  type,
  description,
  options,
  dependsOn,
  parentValue,
  value,
  onChange,
  requiredNotFilled,
  errorMessage,
}: CascadeFieldProps): React.ReactElement => {
  const parentKey = parentValue && parentValue.length > 0 ? parentValue[0] : undefined;

  const items = (parentKey ? childOptionsForParent(options, parentKey) : options) as unknown as EnumOptions;

  return (
    <EntitiesFormField
      // Remount on parent change so the dropdown re-reads its (now-cleared) value.
      key={`${dependsOn}-${parentKey ?? 'all'}`}
      type={type}
      description={description}
      items={items}
      value={value ?? []}
      onChange={onChange}
      requiredNotFilled={requiredNotFilled ?? false}
      errorMessage={errorMessage}
    />
  );
};

export default CascadeField;
